import AlertText from './AlertText'

export default AlertText
